import React, { createContext, useState, useContext, ReactNode } from 'react';
import { SessionData } from '../domain/Session';


interface SessionContextProps {
  sessionData: SessionData | null;
  setSessionData: (data: SessionData) => void;
  redirectUri: string | null;
  setRedirectUri: (uri: string) => void;
}

const SessionContext = createContext<SessionContextProps | undefined>(undefined);

export const SessionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [sessionData, setSessionData] = useState<SessionData | null>(null);
  const [redirectUri, setRedirectUri] = useState<string | null>(null);

  return (
    <SessionContext.Provider value={{ sessionData, setSessionData, redirectUri, setRedirectUri }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = (): SessionContextProps => {
  const context = useContext(SessionContext);
  if (context === undefined) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
};
